import { createNamespace } from '../utils';
import { isNumeric } from '../utils/validate/number'; // Component

import Popup from '../popup';
import Icon from '../icon'; // css

import './index.css';

var _createNamespace = createNamespace('modal-sheet'),
    createComponent = _createNamespace[0],
    bem = _createNamespace[1];

export default createComponent({
  props: {
    value: Boolean,
    size: {
      type: String,
      default: 'normal'
    },
    title: {
      type: String,
      default: ''
    },
    leftIcon: {
      type: Boolean,
      default: false
    },
    leftIconName: {
      type: String,
      default: 'cap-back'
    },
    leftText: {
      type: String,
      default: ''
    },
    leftTextColor: {
      type: String,
      default: '#262626'
    },
    rightIcon: {
      type: Boolean,
      default: false
    },
    rightIconName: {
      type: String,
      default: 'cap-close'
    },
    rightText: {
      type: String,
      default: ''
    },
    rightTextColor: {
      type: String,
      default: '#262626'
    },
    closeOnClickOverlay: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      maxPopUpHeight: 412,
      minPopUPHeight: 120
    };
  },
  methods: {
    headerLeftArea: function headerLeftArea() {
      var h = this.$createElement;

      if (this.leftIcon) {
        return h(Icon, {
          "attrs": {
            "name": this.leftIconName
          },
          "class": bem('header-icon')
        });
      }

      if (this.leftText) {
        return h("span", {
          "class": bem('text'),
          "style": {
            color: this.leftTextColor
          }
        }, [this.leftText]);
      }
    },
    headerRightArea: function headerRightArea() {
      var h = this.$createElement;

      if (this.rightIcon) {
        return h(Icon, {
          "attrs": {
            "name": this.rightIconName
          },
          "class": bem('header-icon')
        });
      }

      if (this.rightText) {
        return h("span", {
          "class": bem('text'),
          "style": {
            color: this.rightTextColor
          }
        }, [this.rightText]);
      }
    },
    getHeader: function getHeader() {
      var h = this.$createElement;
      if (!this.title) return;
      return h("div", {
        "class": bem('header')
      }, [h("div", {
        "on": {
          "click": this.leftClick
        },
        "class": bem('left-area')
      }, [this.headerLeftArea()]), h("div", {
        "class": bem('header-title')
      }, [this.title]), h("div", {
        "on": {
          "click": this.rightClick
        },
        "class": bem('right-area')
      }, [this.headerRightArea()])]);
    },
    togglePopup: function togglePopup(val) {
      this.$emit('input', val);
    },
    leftClick: function leftClick() {
      if (this.leftIcon || this.leftText) {
        this.$emit('titleLeftClick');
      }
    },
    rightClick: function rightClick() {
      if (this.rightIcon || this.rightText) {
        this.$emit('titleRightClick');
      }
    }
  },
  render: function render() {
    var _this = this,
        _bem;

    var h = arguments[0];
    // prop
    var value = this.value,
        size = this.size,
        maxPopUpHeight = this.maxPopUpHeight,
        minPopUPHeight = this.minPopUPHeight;
    var isCusmizeSize = false;
    var popupStyle = {};

    if (isNumeric(size)) {
      isCusmizeSize = true;
      var sizeTmp = Number(size);

      if (sizeTmp > maxPopUpHeight) {
        popupStyle.height = maxPopUpHeight + "px";
      } else if (sizeTmp < minPopUPHeight) {
        popupStyle.height = minPopUPHeight + "px";
      } else {
        popupStyle.height = size + "px";
      }
    }

    if (['normal', 'small', 'large'].includes(size)) isCusmizeSize = false; // methods

    var getHeader = this.getHeader; // evnets

    var createListener = function createListener(name) {
      return function () {
        return _this.$emit(name);
      };
    };

    return h(Popup, {
      "class": bem((_bem = {}, _bem[size] = !isCusmizeSize, _bem)),
      "style": popupStyle,
      "attrs": {
        "value": value,
        "round": true,
        "position": "bottom",
        "getContainer": "body",
        "closeOnClickOverlay": this.closeOnClickOverlay
      },
      "on": {
        "input": this.togglePopup,
        "open": createListener('open'),
        "opened": createListener('opened'),
        "close": createListener('close'),
        "closed": createListener('closed')
      }
    }, [getHeader(), h("div", {
      "class": bem('content')
    }, [this.slots()])]);
  }
});